/**
 * Which proposal the review queue shows after the selected one leaves the
 * list (T-0229 / C2-47). Deciding a proposal in the Pending view drops it
 * from the queue; the reviewer expects the row that was below it, in the
 * order the queue displays (grouped by type, then by confidence), not the
 * first row of the API's order, which made the selection jump.
 *
 * `prevOrder` is the full display order before the change, `visible` the
 * rows on screen now, in display order. Returns the selection to keep:
 *   - the current one while it is still visible;
 *   - else the first row after it in the previous order that is still
 *     visible (the next item), else the nearest one before it;
 *   - else the first visible row; null when nothing is visible.
 */
export function nextSelectionAfter(
  prevOrder: ReadonlyArray<string>,
  prevSelected: string | null,
  visible: ReadonlyArray<string>,
): string | null {
  if (visible.length === 0) return null;
  const shown = new Set(visible);
  if (prevSelected !== null && shown.has(prevSelected)) return prevSelected;
  const at = prevSelected === null ? -1 : prevOrder.indexOf(prevSelected);
  if (at >= 0) {
    for (let i = at + 1; i < prevOrder.length; i += 1) {
      if (shown.has(prevOrder[i]!)) return prevOrder[i]!;
    }
    for (let i = at - 1; i >= 0; i -= 1) {
      if (shown.has(prevOrder[i]!)) return prevOrder[i]!;
    }
  }
  return visible[0]!;
}
